module.exports = __webpack_public_path__ + "images/eurowheelza62ebf046efcdc06590d56eddf4fbad8.png";